import { render } from "./CorporateOnboarding.vue?vue&type=template&id=4bf0f910&scoped=true&ts=true"
import script from "./CorporateOnboarding.vue?vue&type=script&lang=ts"
export * from "./CorporateOnboarding.vue?vue&type=script&lang=ts"

import "./CorporateOnboarding.vue?vue&type=style&index=0&id=4bf0f910&scoped=true&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf0f910"]])

export default __exports__